import { Type } from '@sinclair/typebox';
export var AuditStatus;
(function (AuditStatus) {
    AuditStatus["Safe"] = "Safe";
    AuditStatus["Warning"] = "Warning";
    AuditStatus["Danger"] = "Danger";
})(AuditStatus || (AuditStatus = {}));
export const AuditStatusSchema = Type.Enum(AuditStatus, {
    description: 'Status of the check',
    type: 'string',
    enum: Object.values(AuditStatus),
});
export const BooleanTypeCheckSchema = Type.Object({
    status: AuditStatusSchema,
    value: Type.Boolean(),
});
export const ValueCheckSchema = Type.Object({
    status: AuditStatusSchema,
    value: Type.String(),
});
export const OptionalValueCheckSchema = Type.Object({
    status: AuditStatusSchema,
    value: Type.Optional(Type.String()),
});
export const PercentTypeCheckSchema = Type.Object({
    status: AuditStatusSchema,
    percent: Type.Number(),
    amount: Type.Number(),
});
//# sourceMappingURL=audit-status.js.map